import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { CustomField, IntakeFormSection, IntakeOption, isSmartFieldType } from '@ee/common/models';

@Component({
  selector: 'ee-internal-section',
  template: `
    <div class="section-wrapper" [formGroup]="form">
      @if (editableFields.length && internalFields) {
        <div class="in-row-grid">
          @for (f of editableFields; track f; let i = $index) {
            <ee-field
              [compact]="false"
              [ngClass]="{
                'margin-bottom-sm': i < editableFields.length - 1,
                'md:mb-4': i < editableFields.length - 1,
                'double-column': f.columns === 2,
                'triple-column': f.columns === 3,
                'quad-column': f.columns === 4
              }"
              [hideFromIntake]="true"
              [control]="$any(internalFields.controls[f.field])"
              [field]="f"></ee-field>
          }
        </div>
      }
    </div>
  `,
  styles: [
    `
      .margin-bottom {
        margin-bottom: 1rem;
      }
      .margin-bottom-sm {
        margin-bottom: 0.5rem;
      }
    `
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class InternalSectionComponent {
  @Input() demoMode = false;

  @Input() form: UntypedFormGroup;

  @Input() options: Map<string, IntakeOption> | undefined;

  @Input() internalSection: IntakeFormSection | undefined;

  get internalFields(): UntypedFormGroup | undefined {
    return this.form.get('custom_fields') as UntypedFormGroup;
  }

  /** Smart fields (calculated/offset) are computed, not entered — exclude them from the editable dialog. */
  get editableFields(): CustomField[] {
    return (this.internalSection?.fields ?? []).filter((f) => !isSmartFieldType(f.type));
  }
}
